import { Box, Button, Popover, Typography } from '@mui/material'
import React from 'react'
import { Item } from '../../shared/item.interface';
import { isAPIImage } from '../../utils';
import { Link } from 'react-router-dom';

const ItemPopover = ({ anchor, item }: { anchor: JSX.Element, item: Item }) => {

    const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
      setAnchorEl(event.currentTarget);
    };
  
    const handleClose = () => {
      setAnchorEl(null);
    };
  
    const open = Boolean(anchorEl);
    const id = open ? 'item-popover' : undefined;

  return (
    <>
        <Button disableRipple variant="text" aria-describedby={id} onClick={handleClick}>
            {anchor}
        </Button>
        <Popover
            id={id}
            open={open}
            anchorEl={anchorEl}
            onClose={handleClose}
            anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
            }}
        >
            <Box display="flex" flexDirection="column" alignItems="center" sx={{ p: '1rem', border: '2px solid var(--primary-border)' }}>
                <Box component="img" src={isAPIImage(item.image)} alt={item.name} sx={{ height: '80px', width: '80px' }} />
                <Typography sx={{ textAlign: 'center', width: '100%', mt: '1rem', py: '1rem', borderTop: '2px solid var(--primary-border)', borderBottom: '2px solid var(--primary-border)' }}>{item.name}</Typography>
                <Typography sx={{ mt: '1rem' }}>{item.description}</Typography>
                {item.raffleId && (
                    <Typography className='link' component={Link} to={`/raffle/${item.raffleId}`} sx={{ mt: '1rem' }}>Only usable in this Raffle</Typography>
                )}
            </Box>
      </Popover>
    </>
  )
}

export default ItemPopover